import ListingVM from './listing-vm';
export default {
  init: function () {
    console.log('Initializing Kadenze.AdminCategoryListing');

    //Following options explained here: https://github.com/Knockout-Contrib/Knockout-Validation/wiki/Configuration
    const validationOptions = {
      insertMessages: false,
      errorsAsTitle: true,
      decorateInputElement: true,
      parseInputAttributes: true,
      messagesOnModified: true,
      errorElementClass: 'error',
      errorMessageClass: 'error',
      decorateElementOnModified: true,
      decorateElement: true,
      grouping: { deep: true, observable: true, live: true }
    };

    const categories_data = JSON.parse($('#categories_json').val());
    ko.applyBindingsWithValidation(new ListingVM(categories_data), document.getElementById('admin_category_listing'), validationOptions);
  }
};

